/**
 * CLC TA API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SearchTaType = {
    PrePaid: 'PrePaid',
    DayTrip: 'DayTrip',
    FlightBooking: 'FlightBooking'
} as const;
export type SearchTaType = typeof SearchTaType[keyof typeof SearchTaType];

